import { z } from 'zod'

export const BILLING_PHASE3_READINESS_EXCEPTIONS_CONTRACT_VERSION = '1.0.0' as const

const passthroughResponseSchema = z.object({}).passthrough()

export const billingPhase3ReadinessExceptionResponseSchema = passthroughResponseSchema

export type BillingPhase3ReadinessExceptionResponse = z.infer<typeof billingPhase3ReadinessExceptionResponseSchema>
